// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'navigation';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9.098.563a3.375 3.375 0 0 1 3.375 3.374c0 1.441-2.016 4.183-2.932 5.354a.561.561 0 0 1-.887 0c-.915-1.17-2.931-3.913-2.931-5.354A3.375 3.375 0 0 1 9.098.563z' />
    <path d='M4.601 7.336a1.125 1.125 0 0 0-.83.727l-2.582 7.875a1.125 1.125 0 0 0 1.06 1.5h13.696a1.124 1.124 0 0 0 1.06-1.5l-2.58-7.876a1.124 1.124 0 0 0-.838-.728M5.723 17.437l1.125-6.75m5.625 6.75-1.126-6.75m-9.521 3.376H16.39M2.91 10.688h3.938m4.5 0h3.937M9.108 4.219a.281.281 0 0 1 0-.563m0 .563a.281.281 0 0 0 0-.563' />
  </g>
);

export const viewBox = '0 0 18 18';
